import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { ApiDataClient } from '../../Api/ApiDataClient';
import { ProjectDTO } from '../../Api/ApiServer';

interface UpdateProjectDialogProps {
    open: boolean;
    project?: ProjectDTO | undefined;
    onClose: () => void;
    onRefresh?: () => void;
}
export default function UpdateProjectDialog(props: UpdateProjectDialogProps) {
    const { open, project, onClose, onRefresh } = props;

    const [name, setName] = React.useState<string>();
    const [type, setType] = React.useState<string>('0');
    const [id, setId] = React.useState<number>();
    const [buttonDisabled, setButtonDisabled] = React.useState<boolean>(false);

    useEffect(() => {
        if (project){
            setName(project.name);
            setType(project.type ? project.type.toString() : '0');
            setId(project.id);
        }
        else {
            setName(undefined);
            setType('0');
            setId(undefined);
        }
    }, [project]);

    return (
        <Dialog
            open={open}
            onClose={() => { onClose() }}
            aria-labelledby="create-dialog-title"
            aria-describedby="create-dialog-description"
        >
            <DialogTitle id="create-project-dialog-title" sx={{ background: '#F5F5F5'}}>
                <div  >
                    <div style={{ marginRight: '20px', minWidth: '200px' }}>Úprava projektu</div>
                    <IconButton sx={{ width: '30px', height: '30px', right: '20px', top: '18px', float: 'right', position: 'absolute' }}
                        onClick={() => { setName(undefined); onClose(); }}><Close /></IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                    <div>
                        <TextField sx={{ margin: '12px', width: '526px' }} label={'Název projektu'}
                            size='small'
                            name='userName'
                            variant='outlined'
                            value={name}
                            error={!name}
                            onChange={(e) => { setName(e.target.value) }} />
                        <div style={{ margin: '12px', width: '526px' }}>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="demo-simple-select-standard-label">Typ</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={type}
                                    onChange={(v) => { if (v.target.value) setType(v.target.value) }  }
                                    label="Typ"
                                >
                                    <MenuItem value="0">Neurčeno</MenuItem>
                                    <MenuItem value="1">Silnice</MenuItem>
                                    <MenuItem value="2">Železnice</MenuItem>
                                    <MenuItem value="3">Silniční most</MenuItem>
                                    <MenuItem value="4">Železniční most</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <Button variant='contained' sx={{ margin: 'auto' }} disabled={name === undefined || buttonDisabled} onClick={() => {
                                if (name && type !== undefined && id) {
                                    setButtonDisabled(true);
                                    new ApiDataClient().UpdateProject(name, parseInt(type), id).then((v) => {
                                        setButtonDisabled(false);

                                        if (onRefresh)
                                            onRefresh();

                                        onClose();
                                    });
                                }
                            }}>Uložit</Button>
                        </div>
                    </div>
            </DialogContent>
        </Dialog>
    )
}
